import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Group } from '../models/group.js';
import { createGroupEndpoint } from './const';

export const createGroup = (group: Group) => {
    return getHttpClient().post({ url: createGroupEndpoint, data: JSON.stringify(group) });
};
